const CONSTANTS = {
    ON_LANGAGE_CHANGE: 'app/ON_LANGAGE_CHANGE',
    ON_INVITATION_ACCEPTED: 'app/ON_INVITATION_ACCEPTED',
    ON_SAVED_PREFERENCES_PRESELECTED_METER: 'app/ON_SAVED_PREFERENCES_PRESELECTED_METER',
    ON_SET_SMART_TRAINING_PERIOD: 'app/ON_SET_SMART_TRAINING_PERIOD',
    ON_SET_SMART_TRAINING_MIN_WH: 'app/ON_SET_SMART_TRAINING_MIN_WH',
    ON_SET_DEVICE_FILTER: 'app/ON_SET_DEVICE_FILTER',
    ON_SAVED_PREFERENCES_PRESELECTED_DEVICE: 'app/ON_SAVED_PREFERENCES_PRESELECTED_DEVICE',
    ON_SAVED_PREFERENCES_PRESELECTED_PERIOD: 'app/ON_SAVED_PREFERENCES_PRESELECTED_PERIOD',
    ON_SAVED_PREFERENCES_PRESELECTED_GROUP_BY: 'app/ON_SAVED_PREFERENCES_PRESELECTED_GROUP_BY',
    ON_SAVED_PREFERENCES_PRESELECTED_REFRESH: 'app/ON_SAVED_PREFERENCES_PRESELECTED_REFRESH',
    ON_SHOW_DELETED_RECORDS: 'app/ON_SHOW_DELETED_RECORDS',
    ON_SAVED_PREFERENCES_LEGENDS_VISIBILITY: 'app/ON_SAVED_PREFERENCES_LEGENDS_VISIBILITY',
    ON_PRE_SELECTED_PERIOD_CHANGE: 'app/ON_PRE_SELECTED_PERIOD_CHANGE',
    ON_SAVED_SELECTED_METER_IDS: 'app/ON_SAVED_SELECTED_METER_IDS',
    ON_SAVED_ENERGY_FLOW_POSITION: 'app/ON_SAVED_ENERGY_FLOW_POSITION',
    ON_SAVED_CHART_MODE: 'app/ON_SAVED_CHART_MODE'
};

export { CONSTANTS };
